import { Element, Mode, Type } from "../Form"
import { SelectionComponent } from "../SelectionComponent/SelectionComponent";
import { Selection } from "../SelectionComponent/Selection";
import styles from "./SingleSelection.module.scss";

type Options = {
  question?: string,
  options?: {
    label: string,
    value: string,
    selected: boolean,
  }[],
  renderId?: string,
  required?: boolean,
};

export class SingleSelection extends Selection {
  constructor(options_?: Options) {
    super({...(options_ ?? {}), type: Type.SingleSelectionElement});
  }

  render(mode: Mode, onElementChange: (element: Element) => void): JSX.Element {
    return <SelectionComponent selectionMode="single" key={this.renderId} element={this} mode={mode} onElementChange={onElementChange} />
  }
}